if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // STMODAL2026: on mobile, tapping the photo closes the viewer,
        // and the phone's Back button closes the viewer instead of leaving the page.
        this.addEventListener('click', (event) => {
          if (!this.isMobileView() || !this.hasAttribute('open')) return;
          if (event.target.closest('deferred-media, product-model, .product-media-modal__toggle')) return;
          this.hide();
        });

        window.addEventListener('popstate', () => {
          if (this.stHistoryPushed && this.hasAttribute('open')) {
            this.stHistoryPushed = false;
            super.hide();
          }
        });
      }

      isMobileView() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      hide() {
        const pushed = this.stHistoryPushed;
        this.stHistoryPushed = false;
        super.hide();
        if (pushed && history.state && history.state.stProductModal) history.back();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        if (this.isMobileView() && !this.stHistoryPushed) {
          try {
            history.pushState({ stProductModal: true }, '');
            this.stHistoryPushed = true;
          } catch (e) {}
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          // 2026-10-09: also start Shopify-hosted video on the first tap (was YouTube only)
          (activeMediaContent.querySelector('.js-youtube') || activeMediaContent.querySelector('video'))
        )
          activeMedia.loadContent();
      }
    }
  );
}
